import { inLifeQuotingFieldsData } from '@in-life/constants';

import { inLifeQuotingFieldsEntity } from '@tracking/trackingEvents';

export const getInLifeQuotingFieldsData = () =>
  inLifeQuotingFieldsEntity({
    account_number: inLifeQuotingFieldsData.account_number,
    basket_id: inLifeQuotingFieldsData.basket_id,
  });
